import React from 'react';
import { CreateProps } from '../../../types/utils/CreateProps';
import Button from '../../Button/Button';

type PageNumberProps = CreateProps<
  {
    /** Sets number of the Page */
    number: number;
    /** Sets whether number is active or not */
    active?: boolean;
    /** onClick callback  */
    onClick?: (number: number) => void;
  },
  typeof Button,
  'clickableAppearance' | 'onClick' | 'color' | 'fontWeight'
>;

const PageNumber: React.FunctionComponent<PageNumberProps> = ({
  number,
  active,
  onClick,
  ...props
}) => (
  <Button
    style={{ border: 'none' }}
    size="xl"
    textVariantProps={{
      color: 'purple500',
      hoverColor: 'black',
      fontWeight: 'bold',
    }}
    padding={{ horizontal: 'sm' }}
    block
    disabled={!active}
    onClick={() => onClick && onClick(number)}
    variant="text"
    {...props}
  >
    {number}
  </Button>
);
export default PageNumber;
